import React from 'react';
// import axios from 'axios';
import moment from 'moment';
import { getTranslationCache } from '../../../selectors/language';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import themeSettings from '../../AMM/Utils/themeSettings.json';
import { StyledComponent, StyledModal, StyledTable, StyledForm } from './CSS/style';
import Highlighter from 'react-highlight-words';
import { getList } from './Utils/FormCalls';
// import localStorage from '../../../utils/localStorage';
import { API_BACKUP } from '../../../commons/api';
import { getUserProfile } from '../../../selectors/layout';
import {
  Button,
  Input,
  Form,

  // Select,
  // Tabs,
  Tooltip
} from 'antd';
import history from '../../../commons/history';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
const APIList = {
  getList: `${API_BACKUP.TasksGet}`
};
class TaskScheduler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formObject: {},
      dataSource: [],
      Viewmore: false,
      translationCache: props.translationCache || {},
      userProfile: props && props.userProfile ? props.userProfile : {}
    };
  }
  componentDidMount = async () => {
    let response = await getList(APIList.getList);
    this.setState({
      dataSource: response && Array.isArray(response) ? response : []
    });
  };
  componentDidUpdate = async (prevProps) => {
    if (
      prevProps.translationCache !== this.props.translationCache ||
      this.props.userProfile !== prevProps.userProfile
    ) {
      this.setState({
        translationCache: this.props.translationCache,
        userProfile: this.props.userProfile
      });
    }
  };

  translation = (keyword) => {
    let { translationCache } = this.props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => clearFilters && this.handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });
  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };
  handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    this.setState({ searchText: '' });
  };
  handleAddTask = () => {
    history.push('/rubus/TaskSchedulerDetails');
  };
  editRecord = (record) => {
    history.push({
      pathname: `/rubus/TaskSchedulerDetails/${record.Id}`
    });
  };
  render() {
    const {
      dataSource,
      Viewmore
      // formObject
    } = this.state;

    let columns = [
      {
        title: this.translation('Task Name'),
        dataIndex: 'TaskName',
        key: 'TaskName',
        ...this.getColumnSearchProps('TaskName')
      },
      // {
      //     title: this.translation('Scheduled Time'),
      //     dataIndex: 'ScheduledTime',
      //     key: 'ScheduledTime'
      // },
      {
        title: this.translation('Start Time'),
        key: 'StartDate',
        dataIndex: 'StartDate',
        ...this.getColumnSearchProps('StartDate'),
        sorter: (a, b) => new Date(a.StartDate) - new Date(b.StartDate),
        render: (text) => {
          return {
            children:
              text !== undefined && text !== null ? (
                <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
          };
        }
      },
      {
        title: this.translation('End Time'),
        key: 'EndDate',
        dataIndex: 'EndDate',
        ...this.getColumnSearchProps('EndDate'),
        sorter: (a, b) => new Date(a.EndDate) - new Date(b.EndDate),
        render: (text) => {
          return {
            children:
              text !== undefined && text !== null ? (
                <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
              ) : null
          };
        }
      },
      {
        title: this.translation('Status'),
        dataIndex: 'TaskStatus',
        key: 'TaskStatus',
        ...this.getColumnSearchProps('TaskStatus')
        // sorter: (a, b) => a.Status.localeCompare(b.Status)
      },
      {
        title: this.translation('Action'),
        width: '600',
        render: (text, record) => (
          <>
            {/* <Button
              style={{ marginRight: '5px' }}
              className="ant-btn"
              onClick={() => this.setState({ Viewmore: true })}
              size="middle"
            >
              <Tooltip title={this.translation('View More')}>
                <SmallDashOutlined />
              </Tooltip>
            </Button> */}
            <Tooltip title={this.translation('Edit')}>
              <Button
                style={{ marginRight: '5px' }}
                className="ant-btn"
                onClick={() => {
                  this.editRecord(record);
                }}
                size="middle"
              >
                <EditOutlined />
              </Button>
            </Tooltip>
          </>
        )
      }
      // {
      //     title: this.translation('View More'),
      //     width: '600',
      //     render: (text, record) => (
      //         <>
      //             <Button
      //                 style={{ marginRight: '5px' }}
      //                 className="ant-btn"
      //                 onClick={() => this.setState({ Viewmore: true })}
      //                 size="middle"
      //             >
      //                 <Tooltip title={this.translation('View More')}>
      //                     <SmallDashOutlined />
      //                 </Tooltip>
      //             </Button>
      //         </>
      //     )
      // }
    ];
    // const validateMessages = {
    //     required: this.translation('${label}') + this.translation('is required!')
    // };
    const formItemLayout = { width: '400px', flex: '50%' };
    return (
      <>
        <StyledComponent
          theme={themeSettings}
          style={{
            // padding: '0px 30px',
            minHeight: window.innerHeight - 143,
            margin: '5px'
          }}
        >
          <>
            <div style={{ color: 'white', margin: '20px 20px', fontSize: '30px' }}>
              {this.translation('Task Scheduler')}
            </div>
            <div style={{ float: 'right', marginBottom: '20px' }}>
              <Tooltip title={this.translation('Add Task')}>
                <Button
                  type="primary"
                  //   icon={<PlusOutlined />}
                  onClick={() => history.push('/rubus/TaskSchedulerDetails')}
                >
                  {this.translation('Add Task')}
                </Button>
              </Tooltip>
            </div>
            {/* <div style={{ float: 'right' }}>
              <Tooltip title={this.translation('History')}>
                <Button
                  type="primary"
                  //   icon={<PlusOutlined />}
                  //   onClick={() => this.adQuestionForm()}
                >
                  {this.translation('History')}
                </Button>
              </Tooltip>
            </div> */}
            <div style={{ marginTop: '40px' }}>
              <StyledTable
                theme={themeSettings}
                dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
                columns={columns}
              ></StyledTable>
            </div>
            <StyledModal
              width="1500px"
              open={Viewmore}
              onCancel={() => {
                this.setState({
                  Viewmore: false
                });
              }}
              closable
              theme={themeSettings}
              footer={[
                <>
                  <Button
                    key="back"
                    onClick={() => {
                      this.setState({
                        Viewmore: false
                      });
                    }}
                  >
                    {this.translation('Cancel')}
                  </Button>

                  <Button key="Submit" type="primary" onClick={this.onRealTimeModelSubmit}>
                    {' '}
                    {this.translation('Submit')}{' '}
                  </Button>
                </>
              ]}
            >
              <StyledForm
                className="TaskScheduler"
                name="TaskScheduler"
                ref={this.RealTimeModelRef}
                autoComplete="off"
                // initialValues={RealTimeInfo || {}}
                theme={themeSettings}
                layout="horizontal"
                labelCol={{ flex: '200px' }}
                labelAlign="right"
                onFinish={this.onRealTimeModelSubmit}
                onFinishFailed={this.onFinishFailed}
                labelWrap
                // validateMessages={validateMessages}
                wrapperCol={{ flex: 1 }}
              >
                <div style={{ display: 'flex', flexWrap: 'wrap', width: '1300px' }}>
                  <Form.Item
                    name="DataStorageLocation"
                    label={this.translation('Data Storage Location')}
                    // rules={[{ required: true }]}
                    style={formItemLayout}
                  >
                    <Input disabled={true} style={{ width: '70%' }} />
                  </Form.Item>
                  <Form.Item
                    name="BackupMD5Hash"
                    label={this.translation('Backup MD5 Hash')}
                    style={formItemLayout}
                  >
                    <Input style={{ width: '70%' }} />
                  </Form.Item>
                  <Form.Item
                    label={this.translation('Estimated total size')}
                    name="EstimatedTotalSize"
                    style={formItemLayout}
                  >
                    <Input style={{ width: '70%' }} />
                  </Form.Item>
                  <Form.Item
                    label={this.translation('Activity start')}
                    name="ActivityStart"
                    style={formItemLayout}
                  >
                    <Input style={{ width: '70%' }} />
                  </Form.Item>
                  <Form.Item
                    label={this.translation('Activity end')}
                    name="ActivityEnd"
                    style={formItemLayout}
                  >
                    <Input style={{ width: '70%' }} />
                  </Form.Item>
                  <Form.Item
                    label={this.translation('Status')}
                    name="Status"
                    style={formItemLayout}
                  >
                    <Input style={{ width: '70%' }} />
                  </Form.Item>
                </div>
              </StyledForm>
            </StyledModal>
          </>
        </StyledComponent>
      </>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  translationCache: getTranslationCache(),
  userProfile: getUserProfile()
});
export default connect(mapStateToProps)(TaskScheduler);
